import React from 'react'
import { useSelector } from 'react-redux'
import { Switch, BrowserRouter, Route } from 'react-router-dom'

import NotFound from '../components/common/NotFound'
import CartContainer from '../containers/order/cart/CartContainer'
import App from '../App'
import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import RegisterContainer from '../containers/auth/RegisterContainer'
import ForgotPasswordContainer from '../containers/auth/ForgotPasswordContainer'
import UpdatePasswordContainer from '../containers/auth/UpdatePasswordContainer'
import OrderHistoryContainer from '../containers/order/OrderHistoryContainer'
import OrderDetailsContainer from '../containers/order/OrderDetailsContainer'
import VerifyTable from '../containers/order/VerifyTable'
import MasterLayout from '../containers/layout'
import FoodDynamicDevice from '../containers/FoodDynamicDevice'
import UnSupport from '../components/common/UnSupport'
import VerifyQRCode from '../containers/order/VerifyQRCode'
import OrderTableQRcodeSuccess from '../containers/order/OrderTableQRcodeSuccess'

import paths from './paths'
import { getRestaurantPath } from '../selectors'

const RootRoute = () => {
    const restaurantPath = useSelector(getRestaurantPath)
    return (
        <BrowserRouter basename={`/${restaurantPath}`}>
            <Route
                render={props => (
                    <App {...props}>
                        <Switch>
                            <Route
                                exact
                                path={paths.verifyTable + '/:id/:hash'}
                                component={VerifyTable}
                            />
                            <Route
                                exact
                                path={paths.verifyQRCode + '/:hash'}
                                component={VerifyQRCode}
                            />
                            <MasterLayout>
                                <Switch>
                                    <Route
                                        exact
                                        path={[paths.listFood, paths.home]}
                                        component={FoodDynamicDevice}
                                    />
                                    <Route
                                        exact
                                        path={paths.cartDetail}
                                        component={CartContainer}
                                    />
                                    <PublicRoute
                                        exact
                                        path={paths.register}
                                        component={RegisterContainer}
                                    />
                                    {/* <PublicRoute
                                        exact
                                        path={paths.resetPassword}
                                        component={ResetPasswordContainer}
                                    /> */}
                                    <PublicRoute
                                        exact
                                        path={paths.forgotPassword}
                                        component={ForgotPasswordContainer}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={paths.updatePassword}
                                        component={UpdatePasswordContainer}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={paths.orderHistory}
                                        component={OrderHistoryContainer}
                                    />
                                    <Route
                                        exact
                                        path={[
                                            paths.orderDetails + '/:orderID',
                                            paths.orderDetails,
                                        ]}
                                        component={OrderDetailsContainer}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={paths.updateProfile}
                                        component={RegisterContainer}
                                        isUpdate
                                    />
                                    <Route
                                        exact
                                        path={paths.tableQRcodeSuccess}
                                        component={OrderTableQRcodeSuccess}
                                    />
                                    <Route
                                        exact
                                        path={paths.unSupport}
                                        component={UnSupport}
                                    />
                                    {/* 404 Page */}
                                    <Route
                                        exact
                                        path={paths.notFound}
                                        component={NotFound}
                                    />
                                    <Route component={NotFound} />
                                </Switch>
                            </MasterLayout>
                        </Switch>
                    </App>
                )}
            />
        </BrowserRouter>
    )
}

export default RootRoute
